import React from 'react'
import { Table, Button } from 'reactstrap'
import '../../stylesheets/Provision.css'
import $ from 'jquery'
import { CSVLink } from 'react-csv';

class ExpireControllersReport extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
        }
    }

    printReport = () => {
        $('.report-list').css("max-height", "100%");
        setTimeout(
            function () {
                window.print()
                $('.report-list').css("max-height", "375px");
            },
            500);
    }

    render() {
        let { controllersData, options, allteam } = this.props
        let csvData = []
        let csvFileName = ''
        let pageTitle = ''
        if (options === "1") {
            csvFileName = 'ExpiredController-Report.csv'
            pageTitle = 'Expired Controllers'
        }
        if (options === "2") {
            csvFileName = 'AboutToExpire-Report.csv'
            pageTitle = 'About To Expire Controllers'
        }
        if (options === "3") {
            csvFileName = 'RenewedController-Report.csv'
            pageTitle = 'Renewed Controllers'
        }
        return (<div className="row justify-content-center align-items-center">
            {(controllersData.length > 0 ?
                <div id="provisioned-controllers" className="row justify-content-center align-items-center">
                    <h3 className="col-12">{pageTitle}</h3>
                    <div className="report-list">
                        <Table className="expired-controllers">
                            <tbody>
                            <tr>
                                <th>Controller</th>
                                <th>Current Team</th>
                                <th>Past Team</th>
                                <th>Subscription Plan</th>
                            </tr>
                            {controllersData.map((data, idx) => {
                                csvData.push({
                                    'Controller': data.controller ? data.controller.serial_number : '',
                                    'Team': data.controller.team ? data.controller.team.name : '',
                                    'Past Team': (allteam.length > 0 ? allteam.map((t) =>
                                        (t.id === data.past_team ? t.name : '')
                                    ).join("") : ''),
                                    'Subscription Plan': data.subscription_plan ? data.subscription_plan.name : ''
                                });

                                return (
                                    <tr key={`${idx}`}>
                                        <td>{data.controller ? data.controller.serial_number : '-'}</td>
                                        <td>{data.controller.team ? data.controller.team.name : '-'}</td>
                                        <td>
                                            {allteam.length > 0 ?
                                                allteam.map((t) =>
                                                    (t.id === data.past_team ? t.name : '-')
                                                ) : ''
                                            }
                                        </td>
                                        <td>{data.subscription_plan ? data.subscription_plan.name : '-'}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    </div>
                    <br />
                    <CSVLink data={csvData} filename={csvFileName} className="noprint btn btn-primary export-excel-btn">
                        Export to Excel
                    </CSVLink>
                    <Button className="noprint report-print-btn" color="primary" onClick={this.printReport}>
                        Print
                    </Button>
                </div>
                : null)}
        </div>)
    }
}

export default ExpireControllersReport


// WEBPACK FOOTER //
// ./src/components/ui/ExpireControllersReport.js